<template>
	<div>
		<p>
            <span v-if="$tera.project.AuditWizard.researchEthicsApproval && $tera.project.AuditWizard.researchEthicsApproval.length">
				{{
					selectRandom([
						"Ethics will be obtained via ",
						"Ethics will be acquired through ",
						"Approval for ethics will be obtained through ",
						"Ethics will be approved through "
					])
				}}
			</span>
			<span v-if="$tera.project.AuditWizard.researchEthicsApproval && $tera.project.AuditWizard.researchEthicsApproval.length">
                {{ $tera.project.AuditWizard.researchEthicsApproval + "."}}
            </span>

            <span v-if="$tera.project.AuditWizard.dataStorage && $tera.project.AuditWizard.dataStorage.length">
				{{
					selectRandom([
						"The data will be safely stored in ",
						"Secure storage of the data will take place in ",
						"The storage of the data will be done securely in ",
						"The data is planned to be securely stored within "
					])
				}}
			</span>
			<span v-if="$tera.project.AuditWizard.dataStorage && $tera.project.AuditWizard.dataStorage.length">
                {{ $tera.project.AuditWizard.dataStorage + "."}}
            </span>

			<span v-if="$tera.project.AuditWizard.presentationPlans && $tera.project.AuditWizard.presentationPlans.length">
				{{
					selectRandom([
						"The plans for presentation, publication, and dissemination include ",
						"The presentation, publication, and dissemination plans consist of ",
						"The presentation, publication, and dissemination plans include the following: ",
						"The strategy for presentation, publication, and dissemination involves "
					])
				}}
			</span>
			<span v-if="$tera.project.AuditWizard.presentationPlans && $tera.project.AuditWizard.presentationPlans.length">
                {{ $tera.project.AuditWizard.presentationPlans + "."}}
            </span>

            
			
		</p>
    	</div>
</template>

<script>
import OutputMixin from "@/mixins/OutputMixin.js";
export default {
	name: "OutputAuditSampleSize",
	mixins: [OutputMixin]
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
